import FilterModal from "src/components/common/FilterFrame/FilterModal";
import type { FilterFieldConfig } from "src/components/common/FilterFrame/FilterModal";

export const fields: FilterFieldConfig[] = [
    { key: "name",           label: "Name",            type: "text", default: "" }, // combine firstName, middleName, lastName
    { key: "email",          label: "Email",           type: "text", default: "" },
    { key: "role",           label: "Role",            type: "text", default: "" },
    { key: "phoneNumber",    label: "Mobile Number",   type: "text", default: "" },
    { key: "workphone",      label: "Work Phone",      type: "text", default: "" },
    { key: "extension",      label: "Extension",       type: "text", default: "" },
    { key: "driverLicense",  label: "Driver License",  type: "text", default: "" },
    { key: "ssn",            label: "SSN",             type: "text", default: "" },
    { key: "birthDay",       label: "Birthday",        type: "range", default: "", inputType: "date"},
    { key: "hireDate",       label: "Hire Date",       type: "range", default: "", inputType: "date" },
    { key: "quitDate",       label: "Quit Date",       type: "range", default: "", inputType: "date" },
    { key: "address",        label: "Address",         type: "text", default: "" },
    { key: "background",     label: "Background",      type: "text", default: "" },
    { key: "personel",       label: "Personnel",      type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "edit", label: "Edit"},  
        {value: "view", label: "View"}, 
        {value: "no", label: "No"}
        ] 
    },
    { key: "office",         label: "Office",         type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "yes", label: "Yes"}, 
        {value: "no", label: "No"}
        ]
    },
    { key: "allOffice",      label: "All Office",     type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "edit", label: "Edit"},  
        {value: "view", label: "View"}, 
        {value: "no", label: "No"}
        ] 
    },
    { key: "creatorId", label: "Created By", type: "asyncSelect", default: "",
        fileName: "common/searchUser.php",
        placeholder: "Search User",
        isMulti: false,
    },
    { key: "createdAt", label: "Created At", type: "range", default: "", inputType: "date" },
    { key: "updaterId", label: "Updated By", type: "asyncSelect", default: "", 
        fileName: "common/searchUser.php", 
        placeholder: "Search User", 
        isMulti: false, 
    },
    { key: "updatedAt", label: "Updated At", type: "range", default: "", inputType: "date" },
    { key: "void", label: "Validity", type: "select", default: "no",
        options: [
        { value: "no", label: "Valid" },
        { value: "yes", label: "Void" },
        { value: "all", label: "All" },
        ],
    },
    { key: "voidReason", label: "Void Reason", type: "text", default: "" },
    { key: "validateReason", label: "Validate Reason", type: "text", default: "" },
];

export default function UsersFilterForm() {
    return <FilterModal title="Filter" width={650} fields={fields} />;
}